import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('sw-cms-block-moorl-column-layout-3-2', {
    template,
});
